import { IResponse } from "models";

export enum ActionType {
  GET_DEPARTMENT_LIST_4_DASHBOARD = "action/GET_DEPARTMENT_LIST_4_DASHBOARD",
  GET_DEPARTMENT_LIST_4_DASHBOARD_SUCCESS = "action/GET_DEPARTMENT_LIST_4_DASHBOARD_SUCCESS",
  GET_DEPARTMENT_LIST_4_DASHBOARD_ERROR = "action/GET_DEPARTMENT_LIST_4_DASHBOARD_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IDepartmentList4DashboardResponse extends IResponse {
  result: any;
}
